module.exports = __webpack_public_path__ + "img/8.69a20180.png";